module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADhSURBVHgB1VSBDYJADDyNAzDCj+AIjMAGMgIb4AbqBLoJboAbwAa4AbbaJlUhPD6YcMnBh7b3/ctTYClYyTsmOoTjSqx5kRPbCZlxpw0xIp6Id/wOR9wRbzA7pAjDQXQqK6ofHMYhlrq2S9QGzh7iHC9MTdklytjj5bEGsw4x9j83eY3kuT5R7eDycYJEYqkRYx5lEwyJKrZ4t6Q06wLf9niJwnRXmYK4J8+NEdUCtiAayHmKbuCHWuiFNWbALKJ8fP7f2asCYVC/a37wxZ1qQvEdTnSeOkwzT3lChUy6P+MBQy55o9vj9dgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/icon-email.png
// module id = rWZU
// module chunks = 0